// extracted by mini-css-extract-plugin
module.exports = {"burger":"BurgerMenu_burger__pN_yI","top":"BurgerMenu_top__20rp5","links":"BurgerMenu_links__2tStW"};